import React, { useContext, useEffect} from 'react';
 import cl from './List.module.css'
import { AppContext } from "../../../../providers/appProvider"
import ErrorModal from '../../../UI/ErrorModal/ErrorModal';
import Pagination from '../../../UI/Pagination/Pagination'; 
import { useTranslation } from 'react-i18next';
import tbl from '../../../../assets/Style/Table.module.css'
import { useSalary } from '../../../../hooks/useSalary';
 
const List = () => {
    const {t} = useTranslation();
 
  const {appState, app} = useContext(AppContext);
  const formatDate = (dateString) => {

    const purchasedAtDate = new Date(dateString);

    const months = [t('Jan'), t('Feb'), t('Mar'), t('Apr'), t('May'), t('Jun'), t('Jul'), t('Aug'), t('Sep'), t('Oct'), t('Nov'), t('Dec')];

    const day = purchasedAtDate.getDate();
    const month = months[purchasedAtDate.getMonth()];
    const year = purchasedAtDate.getFullYear();

    return `${day} ${month}  ${year}`;
};
  
  const { salaryService } = useSalary(20); 

  useEffect( ()=> {
    salaryService.fetchList()
  }, [])
   
  return <div>

    <div className={ cl.headMain }> 
        <h1>{t('Salaries')}</h1>   
     </div>
 
    <div className={tbl.table + ' ' + cl.table}>
 
      <table>
        <thead>
            <tr>
            <th className={cl.id} >#</th>
            <th>{t('Saler')}</th>
            <th>{t('Salary')}</th>
            <th>{t('Sold')}</th>
            <th>{t('BonusPercentage')}</th>
            <th>{t('BonusTotal')} </th>
            <th>{t('SalaryTotal')}</th>
            <th>{t('Total')}</th>
            {/*<th>{t('CreatedAt')}</th> */}
            <th>{t('Dateofissue')}</th> 
            </tr>
        </thead>
        <tbody>
            {salaryService.items.map((item) =>
              <tr key={item.id} >
                <td className={cl.id} >{item.id} </td>
                <td>{item.user.firstname}  {item.user.lastname}</td>
                <td>{item.salary}₾ </td>
                <td>{item.number_of_cars} {t('Car')}</td>
                <td>{item.bonus_percent}%</td>
                <td>{item.bonus_total}₾</td>
                <td>{item.salary_total}₾</td>
                <td>{item.total}₾</td>
                {/*<td> { item.created_at ? formatDate(item.created_at) : '' }  </td> */}
                <td>{item.issued_at == true ? formatDate(item.issued_at) : "" }</td> 
              </tr>  
            )}
        </tbody>
      </table>


    </div>

  
   {appState.error && <ErrorModal message={appState.error} onClose={() => app.clearError(false)} />}

    <Pagination total={salaryService.total} 
                perPage={salaryService.filter.limit} 
                current={salaryService.filter.page} 
                paginate={(page) => {
                  salaryService.setFilter({
                    ...salaryService.filter,
                    page: page,
                  });
                }}
                setLimit={(limit) => {
                  salaryService.setFilter({
                    ...salaryService.filter,
                    limit: limit,
                  });
                }}
                />
  </div>;
}

export default List;